module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Jonschwil-c9557c9e904414ec22387f3ed71fa118.png";